import { render, staticRenderFns } from "./device-type-edit.vue?vue&type=template&id=46d8956e&scoped=true&"
import script from "./device-type-edit.vue?vue&type=script&lang=js&"
export * from "./device-type-edit.vue?vue&type=script&lang=js&"
import style0 from "./device-type-edit.vue?vue&type=style&index=0&id=46d8956e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d8956e",
  null
  
)

export default component.exports